import {Injectable, OnDestroy} from "@angular/core";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
// noinspection ES6PreferShortImport
import {SimUtilityService} from "../../core/services/sim-services/sim-utility.service";
// noinspection ES6PreferShortImport
import {SimWindowService} from "../../core/services/sim-services/sim-window.service";
import {
	ConfirmationDialogComponent,
	DialogData_ConfirmationDialog,
} from "./material-dialogs/general-dialogs/confirmation-dialog/confirmation-dialog.component";
import {
	DialogDataAddDebriefingPlayerDialog,
	SelectPlayersDialogComponent,
} from "./material-dialogs/recording-dialogs/add-debriefing-player-dialog/select-players-dialog.component";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "./material-dialogs/basic-material-dialog/basic-material-dialog.directive";
import {
	ConfirmStopRecordingDialogComponent,
	DialogDataConfirmStopRecordingDialog,
} from "./material-dialogs/recording-dialogs/confirm-stop-recording-dialog/confirm-stop-recording-dialog.component";
import {
	DeleteDialogMatComponent,
	DialogData_DeleteDialog,
} from "./material-dialogs/general-dialogs/delete-dialog-mat/delete-dialog-mat.component";
import {
	DialogData_InformationDialog,
	InformationDialogComponent,
} from "./material-dialogs/general-dialogs/information-dialog/information-dialog.component";
import {
	DialogDataParticipantListDialogInput,
	ParticipantListDialogComponent,
} from "./material-dialogs/recording-dialogs/participant-list-dialog/participant-list-dialog.component";
import {
	DialogDataProRecordingFinishedDialog,
	ProRecordingFinishedDialogComponent,
} from "./material-dialogs/recording-dialogs/pro-recording-finished-dialog/pro-recording-finished-dialog.component";
import {
	DialogData_RecorderInitializationDialog,
	RecorderInitializationDialogComponent,
} from "./material-dialogs/recording-dialogs/recorder-initialization-dialog/recorder-initialization-dialog.component";
import {DialogData_SettingsDialog, SettingsDialogComponent} from "./material-dialogs/settings-dialog/settings-dialog.component";
import {
	DialogData_UserCard,
	UserCardMatDialogComponent,
} from "./material-dialogs/general-dialogs/user-card-mat-dialog/user-card-mat-dialog.component";
import {
	CameraTemplateDialogComponent,
	DialogData_CameraTemplateDialog,
} from "./material-dialogs/configuration-dialogs/camera-template-dialog/camera-template-dialog.component";
import {
	CameraResolutionDialogComponent,
	DialogData_CameraResolutionDialog,
} from "./material-dialogs/configuration-dialogs/camera-resolution-dialog/camera-resolution-dialog.component";
import {CameraConfigurationDialogComponent} from "./material-dialogs/configuration-dialogs/camera-configuration-dialog/camera-configuration-dialog.component";
import {
	AudioSelectionDialogComponent,
	DialogData_AudioChannelSelectionDialogInput,
} from "./material-dialogs/configuration-dialogs/audio-selection-dialog/audio-selection-dialog.component";
import {
	CameraSelectionDialogComponent,
	DialogData_CameraSelectionDialogInput,
} from "./material-dialogs/configuration-dialogs/camera-selection-dialog/camera-selection-dialog.component";
import {
	PLAYER_MAPPING_CONFIGURATION_DIALOG_INPUT,
	PlayerMappingConfigurationDialogComponent,
} from "./material-dialogs/web-manager-dialogs/player-mapping-configuration-dialog/player-mapping-configuration-dialog.component";
import {
	AUDIO_CHANNEL_TEMPLATE_INPUT,
	AudioChannelTemplateDialogComponent,
} from "./material-dialogs/web-manager-dialogs/audio-channel-template-dialog/audio-channel-template-dialog.component";
import {
	RECORDER_MAPPINGS_CONFIGURATION_DIALOG_INPUT,
	RecorderMappingsConfigurationDialogComponent,
} from "./material-dialogs/web-manager-dialogs/recorder-mappings-configuration-dialog/recorder-mappings-configuration-dialog.component";
import {
	TRAINING_ROOM_RESTRICTION_DIALOG_INPUT,
	TrainingRoomRestrictionDialogComponent,
} from "./material-dialogs/web-manager-dialogs/training-room-restriction-dialog/training-room-restriction-dialog.component";
import {
	RECORDER_AUDIO_CHANNEL_SELECTION_INPUT,
	RecorderAudioChannelSelectionDialogComponent,
} from "./material-dialogs/web-manager-dialogs/recorder-audio-channel-selection-dialog/recorder-audio-channel-selection-dialog.component";
import {
	MEDIA_DIALOG_BASE_INPUT,
	MediaImageDialogComponent,
} from "./material-dialogs/web-manager-dialogs/media-image-dialog/media-image-dialog.component";
import {MediaVideoDialogComponent} from "./material-dialogs/web-manager-dialogs/media-video-dialog/media-video-dialog.component";
import {MediaPdfDialogComponent} from "./material-dialogs/web-manager-dialogs/media-pdf-dialog/media-pdf-dialog.component";
import {
	SCHEDULER_EVENT_DIALOG_INPUT,
	SchedulerEventDialogComponent,
} from "./material-dialogs/web-manager-dialogs/scheduler-event-dialog/scheduler-event-dialog.component";
import {JOBLOG_DIALOG_INPUT, JobLogDialogComponent} from "./material-dialogs/web-manager-dialogs/job-log-dialog/job-log-dialog.component";
import {PROMPT_DIALOG_INPUT, PromptDialogComponent} from "./material-dialogs/web-manager-dialogs/prompt-dialog/prompt-dialog.component";
import {
	DialogData_EventFilterDialogInput,
	EventFilterDialogComponent,
} from "./material-dialogs/event-dialogs/event-filter-dialog/event-filter-dialog.component";
import {
	DialogData_VersionDialogInput,
	VersionDialogComponent,
} from "./material-dialogs/general-dialogs/version-dialog/version-dialog.component";
import {
	OSCE_TRAINING_ROOM_SELECTION_DIALOG_INPUT,
	OsceTrainingRoomSelectionDialogComponent,
} from "./material-dialogs/web-manager-dialogs/osce-training-room-selection-dialog/osce-training-room-selection-dialog.component";
import {
	DetailedRoomSelectionDialogComponent,
	DialogData_DetailedRoomSelectionInput,
} from "./material-dialogs/general-dialogs/detailed-room-selection-dialog/detailed-room-selection-dialog.component";
import {
	DialogData_PlayerSelectionDialog,
	PlayerSelectionDialogComponent,
} from "./material-dialogs/general-dialogs/player-selection-dialog/player-selection-dialog.component";
import {
	DialogData_DurationDialogInput,
	DurationDialogComponent,
} from "./material-dialogs/general-dialogs/duration-dialog/duration-dialog.component";
import {
	DialogData_HealthLevelReportDialog,
	HealthLevelReportDialogComponent,
} from "./material-dialogs/general-dialogs/health-level-report-dialog/health-level-report-dialog.component";
import {
	DialogData_RoomPlayerSelectionDialogInput,
	RoomPlayerSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/room-player-selection-dialog/room-player-selection-dialog.component";
import {
	DialogData_RoomMediaScreenSelectionDialogInput,
	RoomMediaScreenSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/room-media-screen-selection-dialog/room-media-screen-selection-dialog.component";
import {
	DialogData_RoomRecorderSelectionDialogInput,
	RoomRecorderSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/room-recorder-selection-dialog/room-recorder-selection-dialog.component";
import {
	AddAdHocUserDialogComponent,
	DialogData_AddAdHocUserDialogInput,
} from "./material-dialogs/general-dialogs/add-ad-hoc-user-dialog/add-ad-hoc-user-dialog.component";
import {
	CameraPreviewDialogComponent,
	DialogData_CameraPreviewDialog,
} from "./material-dialogs/general-dialogs/camera-preview-dialog/camera-preview-dialog.component";
import {
	CreateVirtualRoomDialogComponent,
	DialogData_CreateVirtualRoomInput,
} from "./material-dialogs/general-dialogs/create-virtual-room-dialog/create-virtual-room-dialog.component";
import {
	DialogData_ShowRoomDetailDialogInput,
	ShowRoomDetailDialogComponent,
} from "./material-dialogs/general-dialogs/show-room-detail-dialog/show-room-detail-dialog.component";

import {
	CreateEditByNameDialogComponent,
	DialogData_CreateEditByNameDialogInput,
} from "./material-dialogs/general-dialogs/create-edit-by-name-dialog/create-edit-by-name-dialog.component";
import {
	DialogData_EditMediaDialogInput,
	EditMediaDialogComponent,
} from "./material-dialogs/general-dialogs/edit-media-dialog/edit-media-dialog.component";
import {DialogData_ImageDialogInput, ImageDialogComponent} from "./material-dialogs/general-dialogs/image-dialog/image-dialog.component";
import {DialogData_VideoDialogInput, VideoDialogComponent} from "./material-dialogs/general-dialogs/video-dialog/video-dialog.component";
import {
	DialogData_UploadMediaDialogInput,
	UploadMediaDialogComponent,
} from "./material-dialogs/general-dialogs/upload-media-dialog/upload-media-dialog.component";
import {DialogData_PDFDialogInput, PdfDialogComponent} from "./material-dialogs/general-dialogs/pdf-dialog/pdf-dialog.component";
import {
	DialogData_PowerPointDialogInput,
	PowerpointDialogComponent,
} from "./material-dialogs/general-dialogs/powerpoint-dialog/powerpoint-dialog.component";
import {firstValueFrom, Subject, Subscription} from "rxjs";
import {
	ChangeTypeOfChecklistItemComponent,
	DialogData_ChangeTypeOfChecklistItemInput,
} from "./material-dialogs/checklist-dialogs/change-type-of-checklist-entry/change-type-of-checklist-item.component";
import {
	DialogData_GeneralWarningDialogInput,
	GeneralWarningDialogComponent,
} from "./material-dialogs/general-dialogs/general-warning-dialog/general-warning-dialog.component";
import {
	DialogData_InitializeJoinTrainingDialogInput,
	InitializeJoinTrainingDialogComponent,
} from "./material-dialogs/joinTrainingDialogs/initialize-join-training-dialog/initialize-join-training-dialog.component";
import {
	DialogData_JoinTrainingRecordingStoppedDialogInput,
	JoinTrainingRecordingStoppedDialogComponent,
} from "./material-dialogs/joinTrainingDialogs/join-training-recording-stopped-dialog/join-training-recording-stopped-dialog.component";
import {
	DialogData_ChangeRecordingMetaDialogInput,
	OpenChangeRecordingMetaDialogComponent,
} from "./material-dialogs/recording-dialogs/open-change-recording-meta-dialog/open-change-recording-meta-dialog.component";
import {
	ClientRegisterDialogComponent,
	DialogData_ClientRegisterDialog,
} from "./material-dialogs/general-dialogs/client-register-dialog/client-register-dialog.component";
import {NavigationStart, Router} from "@angular/router";
import {
	ContinueTrainingsessionDialogComponent,
	DialogData_ContinueTrainingSessionDialogInput,
} from "./material-dialogs/recording-dialogs/continue-trainingsession-dialog/continue-trainingsession-dialog.component";
import {
	DialogData_PowerOffDialogInput,
	PowerOffDialogComponent,
} from "./material-dialogs/general-dialogs/power-off-dialog/power-off-dialog.component";
import {
	DialogData_ScenarioInformationDialogInput,
	ScenarioInformationDialogComponent,
} from "./material-dialogs/general-dialogs/scenario-information-dialog/scenario-information-dialog.component";
import {
	DatePickerDialogComponent,
	DialogData_DatePickerDialogInput,
} from "./material-dialogs/general-dialogs/date-picker-dialog/date-picker-dialog.component";
import {
	ConfirmSkipSessionRunDialogComponent,
	DialogDataConfirmSkipSessionRunDialogInput,
} from "./material-dialogs/event-dialogs/confirm-skip-session-run-dialog/confirm-skip-session-run-dialog.component";
import {
	CreateNonSimstationRoomDialogComponent,
	DialogData_CreateNonSimstationRoomInput,
} from "./material-dialogs/general-dialogs/create-non-simstation-room-dialog/create-non-simstation-room-dialog.component";
import {
	DialogData_PanelConfigurationDialogInput,
	PanelConfigurationDialogComponent,
} from "./material-dialogs/general-dialogs/panel-configuration-dialog/panel-configuration-dialog.component";
import {
	DialogData_SendEventMailDialogInput,
	SendEventMailDialogComponent,
} from "./material-dialogs/send-event-mail-dialog/send-event-mail-dialog.component";
import {
	DialogData_UploadAttachmentDialogInput,
	UploadAttachmentDialogComponent,
} from "./material-dialogs/general-dialogs/upload-attachment-dialog/upload-attachment-dialog.component";
import {
	CreateSimUserDialogComponent,
	DialogData_CreateSimUserDialogInput,
} from "./material-dialogs/general-dialogs/create-sim-user-dialog/create-sim-user-dialog.component";
import {
	ChangeUserPasswordDialogComponent,
	DialogData_ChangePasswordDialogInput,
} from "./material-dialogs/general-dialogs/change-user-password-dialog/change-user-password-dialog.component";
import {
	DialogData_MoveChecklistItemToGroupInput,
	MoveChecklistItemToGroupDialogComponent,
} from "./material-dialogs/general-dialogs/move-checklist-item-to-group-dialog/move-checklist-item-to-group-dialog.component";
import {
	ChangeScenarioDialogComponent,
	DialogData_ChangeScenarioDialogInput,
} from "./material-dialogs/general-dialogs/change-scenario-dialog/change-scenario-dialog.component";
import {
	CanRecordBlockedDialogComponent,
	DialogData_CanRecordBlockedDialog,
} from "./material-dialogs/general-dialogs/can-record-blocked-dialog/can-record-blocked-dialog.component";
import {
	DialogData_JSONViewDialogInput,
	JsonViewDialogComponent,
} from "./material-dialogs/general-dialogs/json-view-dialog/json-view-dialog.component";
import {
	DialogData_VideoSourceConfigurationDialogInput,
	VideoSourceConfigurationDialogComponent,
} from "./material-dialogs/configuration-dialogs/video-source-configuration-dialog/video-source-configuration-dialog.component";
import {
	DialogData_RecordingExportDialogInput,
	RecordingExportDialogComponent,
} from "./material-dialogs/recording-dialogs/recording-export-dialog/recording-export-dialog.component";
import {
	DialogData_ExportEventDialogInput,
	ExportEventDialogComponent,
} from "./material-dialogs/event-dialogs/export-event-dialog/export-event-dialog.component";
import {ComponentType} from "@angular/cdk/overlay";
import {
	DeleteMediaDialogComponent,
	DialogData_DeleteMediaDialogInput,
} from "./material-dialogs/web-manager-dialogs/delete-media-dialog/delete-media-dialog.component";
import {
	ConfigureApplicationTileDialogComponent,
	DialogData_ConfigureApplicationTileDialogInput,
} from "./material-dialogs/general-dialogs/configure-application-tile-dialog/configure-application-tile-dialog.component";
import {
	DialogData_ImportLibraryArchiveDialogInput,
	ImportLibraryArchiveDialogComponent,
} from "./material-dialogs/general-dialogs/import-library-archive-dialog/import-library-archive-dialog.component";
import {
	CopyEventDialogComponent,
	DialogData_CopyEventDialogInput,
} from "./material-dialogs/event-dialogs/copy-event-dialog/copy-event-dialog.component";
import {
	AudioInputChannelConfigurationDialogComponent,
	DialogData_AudioInputChannelDialogInput,
} from "./material-dialogs/web-manager-dialogs/audio-input-channel-configuration-dialog/audio-input-channel-configuration-dialog.component";

import {
	DialogData_UpdateDialog,
	UpdateCameraResolutionDialogComponent,
} from "./material-dialogs/general-dialogs/update-camera-resolution-dialog/update-camera-resolution-dialog.component";
import {
	DialogData_PowerDistributionUnitConfigurationDialogInput,
	PowerDistributionUnitConfigurationDialogComponent,
} from "./material-dialogs/configuration-dialogs/power-distribution-unit-configuration-dialog/power-distribution-unit-configuration-dialog.component";
import {
	VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_INPUT,
	ViewingStationMappingConfigurationDialogComponent,
} from "./material-dialogs/web-manager-dialogs/viewing-station-mapping-configuration-dialog/viewing-station-mapping-configuration-dialog.component";
import {
	TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_INPUT,
	TrainingRoomPcMappingConfigurationDialogComponent,
} from "./material-dialogs/web-manager-dialogs/training-room-pc-mapping-configuration-dialog/training-room-pc-mapping-configuration-dialog.component";
import {
	TABLET_MAPPING_CONFIGURATION_DIALOG_INPUT,
	TabletMappingConfigurationDialogComponent,
} from "./material-dialogs/web-manager-dialogs/tablet-mapping-configuration-dialog/tablet-mapping-configuration-dialog.component";
import {
	DialogData_GenericListSelectionDialogInput,
	DialogData_GenericListSelectionDialogOutput,
	GenericListSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/generic-list-selection-dialog/generic-list-selection-dialog.component";
import {
	DialogData_ScenarioRecordingFileSetConversionDialogInput,
	ScenarioRecordingFileSetConversionDialogComponent,
} from "./material-dialogs/recording-dialogs/scenario-recording-file-set-conversion-dialog/scenario-recording-file-set-conversion-dialog.component";
import {AssessableItem} from "@models";
import {
	AssignAssessmentDialogComponent,
	DialogData_AssignAssessmentDialogInput,
} from "./material-dialogs/assessment-dialogs/asign-assessment-dialog/assign-assessment-dialog.component";
import {AbortAssessmentDialogComponent} from "./material-dialogs/assessment-dialogs/abort-assessment-dialog/abort-assessment-dialog.component";
import {
	DialogData_UploadFileDialogInput,
	UploadFileDialogComponent,
} from "./material-dialogs/general-dialogs/upload-file-dialog/upload-file-dialog.component";
import {
	DialogData_ReplaceDialog,
	ReplacingDialogComponent,
} from "./material-dialogs/general-dialogs/replacing-dialog/replacing-dialog.component";
import {
	NETWORK_AUDIO_INPUT_CHANNEL_TEMPLATE_INPUT,
	NetworkAudioInputChannelDialogComponent,
} from "./material-dialogs/web-manager-dialogs/network-audio-input-channel-dialog/network-audio-input-channel-dialog.component";
import {
	DialogData_ListViewDialogInput,
	ListViewDialogComponent,
} from "./material-dialogs/general-dialogs/list-view-dialog/list-view-dialog.component";
import {
	ConnectWifiDialogComponent,
	DialogData_ConnectWifiDialogInput,
} from "./material-dialogs/general-dialogs/connect-wifi-dialog/connect-wifi-dialog.component";
import {
	DialogData_LocalizationExcelFileDialogInput,
	UploadLocalizationExcelFileDialogComponent,
} from "./material-dialogs/general-dialogs/upload-localization-excel-file-dialog/upload-localization-excel-file-dialog.component";
import {
	DialogData_UpdateOwnershipDialogInput,
	UpdateOwnershipDialogComponent,
} from "./material-dialogs/general-dialogs/update-ownership-dialog/update-ownership-dialog.component";
import {
	DialogData_ExportAssessmentDialogInput,
	ExportAssessmentsDialogComponent,
} from "./material-dialogs/assessment-dialogs/export-assessments-dialog/export-assessments-dialog.component";
import {
	DialogData_DynamicAudioChannelConfigurationDialogComponentInput,
	DialogData_DynamicAudioChannelConfigurationDialogComponentOutput,
	DynamicAudioChannelConfigurationDialogComponent,
} from "./material-dialogs/recording-dialogs/dynamic-audio-channel-configuration-dialog/dynamic-audio-channel-configuration-dialog.component";
import {
	DialogData_TagSelectionDialogInput,
	TagSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/tag-selection-dialog/tag-selection-dialog.component";
import {
	DialogData_UpdateSimStationDialogInput,
	UpdateSimStationDialogComponent,
} from "./material-dialogs/general-dialogs/update-simstation-dialog/update-sim-station-dialog.component";
import {
	ChangeActivationConditionDialogComponent,
	DialogData_ChangeActivationConditionDialogInput,
} from "./material-dialogs/assessment-dialogs/change-activation-condition-dialog/change-activation-condition-dialog.component";
import {
	CreateBookmarkDialogComponent,
	DialogData_CreateBookmarkDialogInput,
} from "./material-dialogs/general-dialogs/create-bookmark-dialog/create-bookmark-dialog.component";
import {
	DialogData_UserManagerUploadUsersDialogInput,
	UserManagerUploadUsersDialogComponent,
} from "./material-dialogs/web-manager-dialogs/user-manager-upload-users-dialog/user-manager-upload-users-dialog.component";

import {map} from "rxjs/operators";
import {
	DialogData_RegisterDeviceDialogInput,
	RegisterDeviceDialogComponent,
} from "./material-dialogs/general-dialogs/register-device-dialog/register-device-dialog.component";
import {UserLoginDialogComponent} from "./material-dialogs/general-dialogs/user-login-dialog/user-login-dialog.component";
import {
	DialogData_ScanQRCodeDialogInput,
	ScanQrCodeDialogComponent,
} from "./material-dialogs/general-dialogs/scan-qr-code-dialog/scan-qr-code-dialog.component";
import {ShowDeviceRegistrationQrCodeDialogComponent} from "./material-dialogs/general-dialogs/show-device-registration-qr-code-dialog/show-device-registration-qr-code-dialog.component";
import {
	DialogData_PhaseInfoDialogInput,
	PhaseInfoDialogComponent,
} from "./material-dialogs/general-dialogs/phase-info-dialog/phase-info-dialog.component";
import {TeamTrainingSessionDialogComponent} from "./material-dialogs/session-dialogs/team-training-session-dialog/team-training-session-dialog.component";
import {ExamSessionDialogComponent} from "./material-dialogs/session-dialogs/exam-session-dialog/exam-session-dialog.component";
import {PeerPracticeSessionDialogComponent} from "./material-dialogs/session-dialogs/peer-practice-session-dialog/peer-practice-session-dialog.component";
import {
	DialogData_ImportFromCatalogueDialogInput,
	ImportFromCatalogueDialogComponent,
} from "./material-dialogs/assessment-dialogs/import-from-catalogue-dialog/import-from-catalogue-dialog.component";
import {
	DialogData_GenericSelectionDialogInput,
	DialogData_GenericSelectionDialogOutput,
	GenericSelectionDialogComponent,
} from "./material-dialogs/configuration-dialogs/generic-selection-dialog/generic-selection-dialog.component";
import {
	DialogData_StationDetailDialogInput,
	StationDetailDialogComponent,
} from "./material-dialogs/general-dialogs/station-detail-dialog/station-detail-dialog.component";
import {
	ClinicalVignetteDialogComponent,
	DialogData_ClinicalVignetteDialogInput,
} from "./material-dialogs/general-dialogs/clinical-vignette-dialog/clinical-vignette-dialog.component";
import {UntilDestroy} from "@ngneat/until-destroy";
import {
	DialogData_PreviewExamAssessmentDialogInput,
	PreviewExamAssessmentDialogComponent,
} from "./material-dialogs/assessment-dialogs/preview-exam-assessment-dialog/preview-exam-assessment-dialog.component";
import {
	DialogData_ParticipantConfirmationDialogInput,
	ParticipantConfirmationDialogComponent,
} from "./material-dialogs/general-dialogs/participant-confirmation-dialog/participant-confirmation-dialog.component";
import {
	DialogData_SessionReplicationDialogInput,
	SessionReplicationDialogComponent,
} from "./material-dialogs/configuration-dialogs/session-replication-dialog/session-replication-dialog.component";
import {
	DialogData_ExamFlowDetailDialogInput,
	ExamFlowDetailDialogComponent,
} from "./material-dialogs/general-dialogs/exam-flow-detail-dialog/exam-flow-detail-dialog.component";
import {
	CreateAnnouncementDialogComponent,
	DialogData_CreateAnnouncementDialogInput,
} from "./material-dialogs/general-dialogs/create-announcement-dialog/create-announcement-dialog.component";
import {
	MASTER_OF_CEREMONY_AUDIO_CHANNEL_SELECTION_INPUT,
	MasterOfCeremonyAudioChannelSelectionDialogComponent,
} from "./material-dialogs/web-manager-dialogs/master-of-ceremony-audio-channel-selection-dialog/master-of-ceremony-audio-channel-selection-dialog.component";
import {
	DialogData_SessionCompleteDialogInput,
	SessionCompleteDialogComponent,
} from "./material-dialogs/session-dialogs/exam-complete-dialog/session-complete-dialog.component";
import {
	DialogData_RatingItemIconSetConfigurationDialogInput,
	RatingItemIconSetConfigurationDialogComponent,
} from "./material-dialogs/configuration-dialogs/rating-item-icon-set-configuration-dialog/rating-item-icon-set-configuration-dialog.component";
import {
	DialogDataExamParticipantDialogInput,
	ExamParticipantDialogComponent,
} from "./material-dialogs/recording-dialogs/exam-participant-dialog/exam-participant-dialog.component";
import {
	CreateByNameDialogComponent,
	DialogData_CreateByNameDialogInput,
} from "./material-dialogs/new-item-dialogs/generic/create-by-name-dialog.component";
import {
	CreateDraftEventDialogComponent,
	DialogData_CreateDraftEventDialogInput,
} from "./material-dialogs/new-item-dialogs/event/create-draft-event-dialog.component";
import {
	CreateGroupDialogComponent,
	DialogData_CreateGroupInput,
} from "./material-dialogs/new-item-dialogs/group/new-group-dialog/create-group-dialog.component";
import {
	AddGroupMembersDialogComponent,
	DialogData_AddGroupMembersInput,
} from "./material-dialogs/general-dialogs/add-group-members-dialog/add-group-members-dialog.component";
import {
	DialogData_PeerPracticeParticipantDialogInput,
	PeerPracticeParticipantDialogComponent,
} from "./material-dialogs/general-dialogs/peer-practice-participant-dialog/peer-practice-participant-dialog.component";
import {SessionDialogInput} from "@common/models/session-dialog";
import {MultiRoomRecordingSessionDialogComponent} from "./material-dialogs/session-dialogs/multi-room-recording-session-dialog/multi-room-recording-session-dialog.component";
import {
	AssessmentItemProcedureAndReasoningDialogComponent,
	DialogData_AssessmentItemProcedureAndReasoningDialogInput,
} from "./material-dialogs/assessment-dialogs/assessment-item-procedure-and-reasoning-dialog/assessment-item-procedure-and-reasoning-dialog.component";
import {
	CompetenceCategoryGraphDialogComponent,
	DialogData_CompetenceCategoryGraphDialogInput,
} from "./material-dialogs/assessment-dialogs/competence-category-graph-dialog/competence-category-graph-dialog.component";
import {
	DialogData_ExamFlowSessionsDialogInput,
	ExamFlowSessionsDialogComponent,
} from "./material-dialogs/general-dialogs/exam-flow-sessions-dialog/exam-flow-sessions-dialog.component";
import {
	AssignStudentToStationDialogComponent,
	DialogData_AssignStudentToStationDialogInput,
} from "./material-dialogs/general-dialogs/assign-student-to-station-dialog/assign-student-to-station-dialog.component";
import {
	ChangeLanguageDialogComponent,
	DialogDataLanguageDialog,
} from "./material-dialogs/general-dialogs/change-language-dialog/change-language-dialog.component";
import {ExamScheduleSettingsDialogComponent} from "./material-dialogs/general-dialogs/exam-schedule-settings-dialog/exam-schedule-settings-dialog.component";
import {AutomaticRecordingSessionDialogComponent} from "./material-dialogs/session-dialogs/automatic-recording-session-dialog/automatic-recording-session-dialog.component";
import {
	BlockingSessionsDialogComponent,
	DialogData_BlockingSessionDialogInput,
} from "./material-dialogs/event-dialogs/blocking-sessions-dialog/blocking-sessions-dialog.component";

@UntilDestroy()
@Injectable({
	providedIn: "root",
})
export class SimMaterialDialogService implements OnDestroy {
	constructor(
		private _matDialogService: MatDialog,
		private _router: Router,
		private _simWindowService: SimWindowService,
	) {}

	private $OnDestroy = new Subject<void>();

	ngOnDestroy(): void {
		this.$OnDestroy.next();
		this.$OnDestroy.complete();
	}

	public getOpenDialogs(): MatDialogRef<any>[] {
		return this._matDialogService.openDialogs;
	}

	public openConfirmationDialog(input: DialogData_ConfirmationDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(ConfirmationDialogComponent, input, config);
	}

	public openLanguageDialog(input: DialogDataLanguageDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(ChangeLanguageDialogComponent, input, config);
	}

	public openReplaceDialog(input: DialogData_ReplaceDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(ReplacingDialogComponent, input, config);
	}

	public openChangeChecklistEntryType<T extends AssessableItem>(
		input: DialogData_ChangeTypeOfChecklistItemInput<T>,
		config?: MatDialogConfig,
	) {
		return this.openDialog(ChangeTypeOfChecklistItemComponent, input, config);
	}

	public openCreateVirtualRoomDialog(input: DialogData_CreateVirtualRoomInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "700px";
		}
		return this.openDialog(CreateVirtualRoomDialogComponent, input, config);
	}

	public openCreateNonSimstationRoomDialog(input: DialogData_CreateNonSimstationRoomInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "700px";
			config.disableClose = false;
		}
		return this.openDialog(CreateNonSimstationRoomDialogComponent, input, config);
	}

	public openShowRoomDetailDialog(input: DialogData_ShowRoomDetailDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1200px";
		}
		return this.openDialog(ShowRoomDetailDialogComponent, input, config);
	}

	public openAddDebriefingPlayerDialog(input: DialogDataAddDebriefingPlayerDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1100px";
			config.disableClose = false;
		}

		return this.openDialog(SelectPlayersDialogComponent, input, config);
	}

	public openPanelConfigurationDialog(input: DialogData_PanelConfigurationDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.minWidth = "600px";
			config.disableClose = false;
		}

		return this.openDialog(PanelConfigurationDialogComponent, input, config);
	}

	public openContinueTrainingSessionDialog(input: DialogData_ContinueTrainingSessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ContinueTrainingsessionDialogComponent, input, config);
	}

	public openCreateSimUserDialog(input: DialogData_CreateSimUserDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.minWidth = "600px";
			config.disableClose = true;
		}

		return this.openDialog(CreateSimUserDialogComponent, input, config);
	}

	public openChangePasswordDialog(input: DialogData_ChangePasswordDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ChangeUserPasswordDialogComponent, input, config);
	}

	public openMoveChecklistItemToGroup<T extends AssessableItem>(
		input: DialogData_MoveChecklistItemToGroupInput<T>,
		config?: MatDialogConfig,
	) {
		return this.openDialog(MoveChecklistItemToGroupDialogComponent, input, config);
	}

	public openEditMediaDialog(input: DialogData_EditMediaDialogInput, config?: MatDialogConfig) {
		return this.openDialog(EditMediaDialogComponent, input, config);
	}

	public openCopyEventDialog(input: DialogData_CopyEventDialogInput, config?: MatDialogConfig) {
		return this.openDialog(CopyEventDialogComponent, input, config);
	}

	public openScenarioInformationDialog(input: DialogData_ScenarioInformationDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		config.width = "700px";
		return this.openDialog(ScenarioInformationDialogComponent, input, config);
	}

	public openGeneralWarningDialog(input: DialogData_GeneralWarningDialogInput, config?: MatDialogConfig) {
		return this.openDialog(GeneralWarningDialogComponent, input, config);
	}

	public openImageDialog(input: DialogData_ImageDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "90vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(ImageDialogComponent, input, config);
	}

	public openJSONViewDialog(input: DialogData_JSONViewDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "60vw";
			config.height = "80vh";
			config.disableClose = false;
		}
		return this.openDialog(JsonViewDialogComponent, input, config);
	}

	public openVideoDialog(input: DialogData_VideoDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "90vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(VideoDialogComponent, input, config);
	}

	public openPDFDialog(input: DialogData_PDFDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "90vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(PdfDialogComponent, input, config);
	}

	public openPowerPointDialog(input: DialogData_PowerPointDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "90vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(PowerpointDialogComponent, input, config);
	}

	public openUploadMediaDialog(input: DialogData_UploadMediaDialogInput, config?: MatDialogConfig) {
		return this.openDialog(UploadMediaDialogComponent, input, config);
	}

	public openUploadAttachmentDialog(input: DialogData_UploadAttachmentDialogInput, config?: MatDialogConfig) {
		return this.openDialog(UploadAttachmentDialogComponent, input, config);
	}

	public openUserManagerUploadUsersDialog(input: DialogData_UserManagerUploadUsersDialogInput, config?: MatDialogConfig) {
		return this.openDialog(UserManagerUploadUsersDialogComponent, input, config);
	}

	public openImportLibraryArchiveDialog(input: DialogData_ImportLibraryArchiveDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ImportLibraryArchiveDialogComponent, input, config);
	}

	public openUploadFileDialog(input: DialogData_UploadFileDialogInput, config?: MatDialogConfig) {
		return this.openDialog(UploadFileDialogComponent, input, config);
	}

	public openUploadLocalizationExcelFileDialog(input: DialogData_LocalizationExcelFileDialogInput, config?: MatDialogConfig) {
		return this.openDialog(UploadLocalizationExcelFileDialogComponent, input, config);
	}

	public openRecordingExportDialog(input: DialogData_RecordingExportDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "50vw";
			config.minHeight = "90vh";
			config.height = "90vh";
			config.disableClose = false;
		}

		return this.openDialog(RecordingExportDialogComponent, input, config);
	}

	public openScenarioRecordingFileSetConversionDialog(
		input: DialogData_ScenarioRecordingFileSetConversionDialogInput,
		config?: MatDialogConfig,
	) {
		if (!config) {
			config = {};
			config.width = "50vw";
			config.minHeight = "90vh";
			config.height = "90vh";
			config.disableClose = false;
		}

		return this.openDialog(ScenarioRecordingFileSetConversionDialogComponent, input, config);
	}

	public openEventExportDialog(input: DialogData_ExportEventDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "50vw";
			config.minHeight = "90vh";
			config.height = "90vh";
			config.disableClose = false;
		}

		return this.openDialog(ExportEventDialogComponent, input, config);
	}

	public openAssessmentExportDialog(input: DialogData_ExportAssessmentDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "50vw";
			config.minHeight = "90vh";
			config.height = "90vh";
			config.disableClose = false;
		}

		return this.openDialog(ExportAssessmentsDialogComponent, input, config);
	}

	public openSendEventMailDialog(input: DialogData_SendEventMailDialogInput, config?: MatDialogConfig) {
		return this.openDialog(SendEventMailDialogComponent, input, config);
	}

	public openCreateByNameDialog(input: DialogData_CreateByNameDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(CreateByNameDialogComponent, input, config);
	}

	public openCreateEditByNameDialog(input: DialogData_CreateEditByNameDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(CreateEditByNameDialogComponent, input, config);
	}

	public openConfirmStopRecordingDialog(input: DialogDataConfirmStopRecordingDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "650px";
		}
		return this.openDialog(ConfirmStopRecordingDialogComponent, input, config);
	}

	public openDeleteDialog(input: DialogData_DeleteDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(DeleteDialogMatComponent, input, config);
	}

	public openDeleteMediaDialog(input: DialogData_DeleteMediaDialogInput, config?: MatDialogConfig) {
		return this.openDialog(DeleteMediaDialogComponent, input, config);
	}

	public openSkipSessionRunDialog(input: DialogDataConfirmSkipSessionRunDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ConfirmSkipSessionRunDialogComponent, input, config);
	}

	public openDatePickerDialog(input: DialogData_DatePickerDialogInput, config?: MatDialogConfig) {
		return this.openDialog(DatePickerDialogComponent, input, config);
	}

	public openInformationDialog(input: DialogData_InformationDialog, config?: MatDialogConfig) {
		return this.openDialog(InformationDialogComponent, input, config);
	}

	public openListViewDialog(input: DialogData_ListViewDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ListViewDialogComponent, input, config);
	}

	public openPlayerSelectionDialog(input: DialogData_PlayerSelectionDialog, config?: MatDialogConfig) {
		return this.openDialog(PlayerSelectionDialogComponent, input, config);
	}

	public openHealthLevelReportDialog(input: DialogData_HealthLevelReportDialog, config?: MatDialogConfig) {
		return this.openDialog(HealthLevelReportDialogComponent, input, config);
	}

	public openJoinTrainingRecordingStoppedDialog(input: DialogData_JoinTrainingRecordingStoppedDialogInput, config?: MatDialogConfig) {
		return this.openDialog(JoinTrainingRecordingStoppedDialogComponent, input, config);
	}

	public openChangeScenarioDialog(input: DialogData_ChangeScenarioDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ChangeScenarioDialogComponent, input, config);
	}

	public openDynamicAudioChannelConfigurationDialog(
		input: DialogData_DynamicAudioChannelConfigurationDialogComponentInput,
		config?: MatDialogConfig,
	): Promise<DialogData_DynamicAudioChannelConfigurationDialogComponentOutput> {
		if (!config) {
			config = {};
			config.disableClose = false;
			config.width = "1200px";
			config.height = "800px";
		}
		return this.openDialog(DynamicAudioChannelConfigurationDialogComponent, input, config);
	}

	public openParticipantListDialog(input: DialogDataParticipantListDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(ParticipantListDialogComponent, input, config);
	}

	public openExamParticipantDialog(input: DialogDataExamParticipantDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ExamParticipantDialogComponent, input, config);
	}

	public openUpdateOwnershipDialog(input: DialogData_UpdateOwnershipDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(UpdateOwnershipDialogComponent, input, config);
	}

	public openProRecordingFinishedDialog(input: DialogDataProRecordingFinishedDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = true;
			config.width = "1000px";
		}
		return this.openDialog(ProRecordingFinishedDialogComponent, input, config);
	}

	public openRecorderInitializationDialog(input: DialogData_RecorderInitializationDialog, config?: MatDialogConfig) {
		return this.openDialog(RecorderInitializationDialogComponent, input, config);
	}

	public openJoinTrainingInitializationDialog(input: DialogData_InitializeJoinTrainingDialogInput, config?: MatDialogConfig) {
		return this.openDialog(InitializeJoinTrainingDialogComponent, input, config);
	}

	public openUpdateDialog(input: DialogData_UpdateDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = true;
		}
		return this.openDialog(UpdateCameraResolutionDialogComponent, input, config);
	}

	public openDurationDialog(input: DialogData_DurationDialogInput, config?: MatDialogConfig) {
		return this.openDialog(DurationDialogComponent, input, config);
	}

	public openSettingsDialog(input: DialogData_SettingsDialog, config?: MatDialogConfig) {
		config = SimUtilityService.copy(
			{
				maxWidth: "95vw",
				maxHeight: "98vh",
				height: "98vh",
				width: "72vw",
			},
			config,
		);

		if (this._simWindowService.isTwoScreen) {
			config = SimUtilityService.copy(
				{
					maxWidth: "1300px",
					maxHeight: "1000px",
					height: "98vh",
					width: "72vw",
				},
				config,
			);
		}
		config.disableClose = false;

		return this.openDialog(SettingsDialogComponent, input, config);
	}

	public openConfigureAppTileDialog(input: DialogData_ConfigureApplicationTileDialogInput, config?: MatDialogConfig) {
		config = SimUtilityService.copy(
			{
				maxWidth: "50vw",
				width: "50vw",
			},
			config,
		);

		return this.openDialog(ConfigureApplicationTileDialogComponent, input, config);
	}

	public openUserCardMatDialog(input: DialogData_UserCard, config?: MatDialogConfig) {
		return this.openDialog(UserCardMatDialogComponent, input, config);
	}

	public openCameraTemplateDialog(input: DialogData_CameraTemplateDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(CameraTemplateDialogComponent, input, config);
	}

	public openCameraResolutionDialog(input: DialogData_CameraResolutionDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1500px";
			config.disableClose = false;
		}
		return this.openDialog(CameraResolutionDialogComponent, input, config);
	}

	public openCameraConfigurationDialog(input: DialogData_VideoSourceConfigurationDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1200px";
			config.disableClose = false;
		}
		return this.openDialog(CameraConfigurationDialogComponent, input, config);
	}

	public openVideoSourceConfigurationDialog(input: DialogData_VideoSourceConfigurationDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1300px";
			config.disableClose = false;
		}
		return this.openDialog(VideoSourceConfigurationDialogComponent, input, config);
	}

	public openAudioChannelSelectionDialog(input: DialogData_AudioChannelSelectionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1200px";
			config.disableClose = false;
		}
		return this.openDialog(AudioSelectionDialogComponent, input, config);
	}

	public openCameraSelectionDialog(input: DialogData_CameraSelectionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(CameraSelectionDialogComponent, input, config);
	}

	public openRoomPlayerSelectionDialog(input: DialogData_RoomPlayerSelectionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1100px";
			config.disableClose = false;
		}
		return this.openDialog(RoomPlayerSelectionDialogComponent, input, config);
	}

	public openRoomMediaScreenSelectionDialog(input: DialogData_RoomMediaScreenSelectionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(RoomMediaScreenSelectionDialogComponent, input, config);
	}

	public openRecorderSelectionDialog(input: DialogData_RoomRecorderSelectionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(RoomRecorderSelectionDialogComponent, input, config);
	}

	public openAudioChannelTemplateDialog(input: AUDIO_CHANNEL_TEMPLATE_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(AudioChannelTemplateDialogComponent, input, config);
	}

	public openNetworkAudioInputChannelTemplateDialog(input: NETWORK_AUDIO_INPUT_CHANNEL_TEMPLATE_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(NetworkAudioInputChannelDialogComponent, input, config);
	}

	public openPlayerMappingConfigurationDialog(input: PLAYER_MAPPING_CONFIGURATION_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1100px";
			config.disableClose = false;
		}
		return this.openDialog(PlayerMappingConfigurationDialogComponent, input, config);
	}

	public openRecorderMappingsConfigurationDialog(input: RECORDER_MAPPINGS_CONFIGURATION_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1100px";
			config.disableClose = false;
		}
		return this.openDialog(RecorderMappingsConfigurationDialogComponent, input, config);
	}

	public openViewingStationMappingConfigurationDialog(
		input: VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_INPUT,
		config?: MatDialogConfig,
	) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(ViewingStationMappingConfigurationDialogComponent, input, config);
	}

	public openTrainingRoomPcMappingConfigurationDialog(
		input: TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_INPUT,
		config?: MatDialogConfig,
	) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(TrainingRoomPcMappingConfigurationDialogComponent, input, config);
	}

	public openTabletMappingConfigurationDialog(input: TABLET_MAPPING_CONFIGURATION_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(TabletMappingConfigurationDialogComponent, input, config);
	}

	public openAudioInputChannelConfigurationDialog(input: DialogData_AudioInputChannelDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(AudioInputChannelConfigurationDialogComponent, input, config);
	}

	public openTrainingRoomRestrictionDialog(input: TRAINING_ROOM_RESTRICTION_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(TrainingRoomRestrictionDialogComponent, input, config);
	}

	public openTrainingSelectionDialog(inputData: OSCE_TRAINING_ROOM_SELECTION_DIALOG_INPUT, config?: MatDialogConfig) {
		return this.openDialog(OsceTrainingRoomSelectionDialogComponent, inputData, config);
	}

	public openRecorderAudioChannelSelectionDialog(input: RECORDER_AUDIO_CHANNEL_SELECTION_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1400px";
			config.disableClose = false;
		}
		return this.openDialog(RecorderAudioChannelSelectionDialogComponent, input, config);
	}

	public openMasterOfCeremonyAudioChannelSelectionDialog(
		input: MASTER_OF_CEREMONY_AUDIO_CHANNEL_SELECTION_INPUT,
		config?: MatDialogConfig,
	) {
		if (!config) {
			config = {};
			config.width = "700px";
			config.disableClose = false;
		}
		return this.openDialog(MasterOfCeremonyAudioChannelSelectionDialogComponent, input, config);
	}

	public openMediaImageDialog(input: MEDIA_DIALOG_BASE_INPUT, config?: MatDialogConfig) {
		return this.openDialog(MediaImageDialogComponent, input, config);
	}

	public openMediaVideoDialog(input: MEDIA_DIALOG_BASE_INPUT, config?: MatDialogConfig) {
		return this.openDialog(MediaVideoDialogComponent, input, config);
	}

	public openMediaPdfDialog(input: MEDIA_DIALOG_BASE_INPUT, config?: MatDialogConfig) {
		return this.openDialog(MediaPdfDialogComponent, input, config);
	}

	public openPromptDialog(input: PROMPT_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(PromptDialogComponent, input, config);
	}

	public openJobLogDialog(input: JOBLOG_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1300px";
		}
		return this.openDialog(JobLogDialogComponent, input, config);
	}

	public openSchedulerEventDialog(input: SCHEDULER_EVENT_DIALOG_INPUT, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1200px";
			config.disableClose = false;
		}
		return this.openDialog(SchedulerEventDialogComponent, input, config);
	}

	public openEventFilterDialog(input: DialogData_EventFilterDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(EventFilterDialogComponent, input, config);
	}

	public openVersionDialog(input: DialogData_VersionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(VersionDialogComponent, input, config);
	}

	public openUpdateSimStationDialog(input: DialogData_UpdateSimStationDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "800px";
			config.disableClose = false;
		}
		return this.openDialog(UpdateSimStationDialogComponent, input, config);
	}

	public openPowerOffDialog(input: DialogData_PowerOffDialogInput, config?: MatDialogConfig) {
		return this.openDialog(PowerOffDialogComponent, input, config);
	}

	public openChangeRecordingMetaDialog(input: DialogData_ChangeRecordingMetaDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}
		return this.openDialog(OpenChangeRecordingMetaDialogComponent, input, config);
	}

	public openDetailedTrainingRoomSelection(input: DialogData_DetailedRoomSelectionInput, config?: MatDialogConfig) {
		return this.openDialog(DetailedRoomSelectionDialogComponent, input, config);
	}

	public openAddAdHocUserDialog(input: DialogData_AddAdHocUserDialogInput, config?: MatDialogConfig) {
		return this.openDialog(AddAdHocUserDialogComponent, input, config);
	}

	public openClientRegisterDialog(input: DialogData_ClientRegisterDialog, config?: MatDialogConfig) {
		config ??= {};
		config.width = "100%";
		config.height = "100%";
		config.maxHeight = "100vh";
		config.panelClass = "fullscreen-dialog";

		return this.openDialog(ClientRegisterDialogComponent, input, config);
	}

	public openCanRecordBlockedDialog(input: DialogData_CanRecordBlockedDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = true;
			config.width = "1000px";
		}

		return this.openDialog(CanRecordBlockedDialogComponent, input, config);
	}

	public openGenericSelectionDialog<
		T extends {
			id: string;
			name: string;
		},
	>(input: DialogData_GenericSelectionDialogInput<T>, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}

		return this.openDialog<
			GenericSelectionDialogComponent<T>,
			DialogData_GenericSelectionDialogInput<T>,
			DialogData_GenericSelectionDialogOutput
		>(GenericSelectionDialogComponent, input, config);
	}

	public openGenericListSelectionDialog<
		T extends {
			id: string;
			name: string;
		},
	>(input: DialogData_GenericListSelectionDialogInput<T>, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = false;
		}

		return this.openDialog<
			GenericListSelectionDialogComponent<T>,
			DialogData_GenericListSelectionDialogInput<T>,
			DialogData_GenericListSelectionDialogOutput
		>(GenericListSelectionDialogComponent, input, config);
	}

	public openCameraPreviewDialog(input: DialogData_CameraPreviewDialog, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1000px";
			config.disableClose = false;
		}
		return this.openDialog(CameraPreviewDialogComponent, input, config);
	}

	public openPowerDistributionUnitConfigurationDialog(
		input: DialogData_PowerDistributionUnitConfigurationDialogInput,
		config?: MatDialogConfig,
	) {
		return this.openDialog(PowerDistributionUnitConfigurationDialogComponent, input, config);
	}

	public openAssignAssessmentDialog(input: DialogData_AssignAssessmentDialogInput, config?: MatDialogConfig) {
		return this.openDialog(AssignAssessmentDialogComponent, input, config);
	}

	public openAbortAssessmentDialog(config?: MatDialogConfig) {
		return this.openDialog(AbortAssessmentDialogComponent, {}, config);
	}

	public openChangeActivationConditionDialog<T extends AssessableItem>(
		input: DialogData_ChangeActivationConditionDialogInput<T>,
		config?: MatDialogConfig,
	) {
		return this.openDialog(ChangeActivationConditionDialogComponent, input, config);
	}

	public openConnectWifiDialog(input: DialogData_ConnectWifiDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ConnectWifiDialogComponent, input, config);
	}

	public closeAllDialogs() {
		this._matDialogService.closeAll();
	}

	public openTagSelectionTrainingRoomDialog(input: DialogData_TagSelectionDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "1200px";
			config.disableClose = false;
		}
		return this.openDialog(TagSelectionDialogComponent, input, config);
	}

	public openCreateBookmarkDialog(input: DialogData_CreateBookmarkDialogInput, config?: MatDialogConfig) {
		return this.openDialog(CreateBookmarkDialogComponent, input, config);
	}

	public openCreateDraftEventDialog(input: DialogData_CreateDraftEventDialogInput) {
		return this.openDialog(CreateDraftEventDialogComponent, input, {
			disableClose: false,
		});
	}

	public openTeamTrainingSessionDialog(input: SessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(TeamTrainingSessionDialogComponent, input, {
			height: "900px",
			width: "1200px",
			disableClose: true,

			...config,
		});
	}

	public openExamSessionDialog(input: SessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ExamSessionDialogComponent, input, {
			height: "95vh",
			maxHeight: "1000px",
			width: "1400px",
			disableClose: true,
			...config,
		});
	}

	public openPeerPracticeSessionDialog(input: SessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(PeerPracticeSessionDialogComponent, input, {
			height: "900px",
			width: "1400px",
			disableClose: true,
			...config,
		});
	}

	public openMultiRoomRecordingSessionDialog(input: SessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(MultiRoomRecordingSessionDialogComponent, input, {
			height: "800px",
			width: "1400px",
			disableClose: true,
			...config,
		});
	}

	public openAutomaticRecordingSessionDialog(input: SessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(AutomaticRecordingSessionDialogComponent, input, {
			height: "900px",
			width: "1400px",
			disableClose: true,
			...config,
		});
	}

	openRegisterDeviceDialog(input: DialogData_RegisterDeviceDialogInput, config?: MatDialogConfig) {
		return this.openDialog(RegisterDeviceDialogComponent, input, {
			width: "1400px",
			disableClose: true,
			...config,
		});
	}

	openScanQRCodeDialog(input: DialogData_ScanQRCodeDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "600px";
			config.disableClose = false;
		}

		return this.openDialog(ScanQrCodeDialogComponent, input, config);
	}

	openDeviceIDQRCodeDialog(input: MatDialogDataBaseInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "400px";
			config.disableClose = false;
		}

		return this.openDialog(ShowDeviceRegistrationQrCodeDialogComponent, input, config);
	}

	openLoginUserDialog(input: MatDialogDataBaseInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.disableClose = true;
		}

		return this.openDialog(UserLoginDialogComponent, input, config);
	}

	public openImportFromAssessmentCatalogueDialog(input: DialogData_ImportFromCatalogueDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ImportFromCatalogueDialogComponent, input, config);
	}

	public openPreviewExamAssessmentDialog(input: DialogData_PreviewExamAssessmentDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "98vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(PreviewExamAssessmentDialogComponent, input, config);
	}

	public openClinicalVignetteDialog(input: DialogData_ClinicalVignetteDialogInput, config?: MatDialogConfig) {
		if (!config) {
			config = {};
			config.width = "90vw";
			config.height = "90vh";
			config.disableClose = false;
		}
		return this.openDialog(ClinicalVignetteDialogComponent, input, config);
	}

	public openPhaseInfoDialog(param: DialogData_PhaseInfoDialogInput, config?: MatDialogConfig) {
		return this.openDialog(PhaseInfoDialogComponent, param, config);
	}

	public openStationDetailDialog(param: DialogData_StationDetailDialogInput, config?: MatDialogConfig) {
		return this.openDialog(StationDetailDialogComponent, param, config);
	}

	public openParticipantConfirmationDialog(param: DialogData_ParticipantConfirmationDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ParticipantConfirmationDialogComponent, param, config);
	}

	public openCreateAnnouncementDialog(param: DialogData_CreateAnnouncementDialogInput, config?: MatDialogConfig) {
		return this.openDialog(CreateAnnouncementDialogComponent, param, {
			width: "860px",
			...config,
		});
	}

	public openSessionReplicationSettingsDialog(param: DialogData_SessionReplicationDialogInput, config?: MatDialogConfig) {
		return this.openDialog(SessionReplicationDialogComponent, param, config);
	}

	public openExamFlowDetailDialog(param: DialogData_ExamFlowDetailDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ExamFlowDetailDialogComponent, param, {
			width: "800px",
			...config,
		});
	}

	public openSessionCompleteDialog(param: DialogData_SessionCompleteDialogInput, config?: MatDialogConfig) {
		return this.openDialog(SessionCompleteDialogComponent, param, {
			width: "auto",
			minWidth: "500px",
			...config,
		});
	}

	public openCreateGroupDialog(param: DialogData_CreateGroupInput, config?: MatDialogConfig) {
		return this.openDialog(CreateGroupDialogComponent, param, config);
	}

	public openAddGroupMembersDialog(param: DialogData_AddGroupMembersInput, config?: MatDialogConfig) {
		return this.openDialog(AddGroupMembersDialogComponent, param, config);
	}

	public openRatingItemIconSetConfigDialog(param: DialogData_RatingItemIconSetConfigurationDialogInput, config?: MatDialogConfig) {
		return this.openDialog(RatingItemIconSetConfigurationDialogComponent, param, {
			minWidth: "1200px",
			width: "auto",
			...config,
		});
	}

	async openPeerPracticeParticipantDialog(param: DialogData_PeerPracticeParticipantDialogInput, config?: MatDialogConfig) {
		return this.openDialog(PeerPracticeParticipantDialogComponent, param, config);
	}

	public openAssessmentItemProcedureAndReasoningDialog(
		param: DialogData_AssessmentItemProcedureAndReasoningDialogInput,
		config?: MatDialogConfig,
	) {
		return this.openDialog(AssessmentItemProcedureAndReasoningDialogComponent, param, {
			minWidth: "500px",
			...config,
		});
	}

	public openCompetenceCategoryGraphDialog(param: DialogData_CompetenceCategoryGraphDialogInput, config?: MatDialogConfig) {
		return this.openDialog(CompetenceCategoryGraphDialogComponent, param, {
			minWidth: "600px",
			...config,
		});
	}

	public openExamFlowSessionsDialog(param: DialogData_ExamFlowSessionsDialogInput, config?: MatDialogConfig) {
		return this.openDialog(ExamFlowSessionsDialogComponent, param, {
			minWidth: "850px",
			...config,
		});
	}

	public openAssignStudentToStationDialog(param: DialogData_AssignStudentToStationDialogInput, config?: MatDialogConfig) {
		return this.openDialog(AssignStudentToStationDialogComponent, param, {
			minWidth: "550px",
			...config,
		});
	}

	public openExamScheduleSettingsDialog(config: MatDialogConfig) {
		return this.openDialog(
			ExamScheduleSettingsDialogComponent,
			{},
			{
				minWidth: "400px",
				...config,
			},
		);
	}

	async openManageBlockingSessionsDialog(param: DialogData_BlockingSessionDialogInput, config?: MatDialogConfig) {
		return this.openDialog(BlockingSessionsDialogComponent, param, {
			minWidth: "650px",
			...config,
		});
	}

	private openDialog<T, D extends MatDialogDataBaseInput, R extends MatDialogDataBaseOutput>(
		component: ComponentType<BasicMaterialDialog<T, D, R>>,
		input?: D,
		config?: MatDialogConfig<D>,
	) {
		config ??= {};
		config.width ??= "500px";
		config.panelClass ??= "no-padding-dialog";
		config.data = input;
		config.disableClose ??= true;
		config.hasBackdrop ??= true;
		config.ariaLabelledBy = "dialog-title";
		config.autoFocus = false;

		let dialog = this._matDialogService.open<BasicMaterialDialog<T, D, R>, D, R>(component, config);

		// Unsubscribe from the dialog and router events when the dialog is closed
		const subs: Subscription[] = [];
		const closeDialogAndUnsubAll = () => {
			dialog?.close();
			unsubAll();
		};
		const unsubAll = () => {
			subs.forEach((sub) => sub?.unsubscribe());
		};

		subs.push(
			this._router.events.subscribe(async (event) => {
				if (event instanceof NavigationStart) {
					closeDialogAndUnsubAll();
				}
			}),
		);

		subs.push(
			this.$OnDestroy.subscribe(() => {
				closeDialogAndUnsubAll();
			}),
		);

		return firstValueFrom(
			dialog.afterClosed().pipe(
				// Ensure if the dialog is closed without a result, we return a close action
				// to prevent null pointer exceptions
				map((result) => {
					unsubAll();
					if (result === undefined) {
						return {action: "close"} as R;
					} else {
						return result;
					}
				}),
			),
		);
	}
}
